import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <Container>
        <Row className="gy-4">
          <div className="col-lg-5 col-md-12 footer-info">
            <div>
              Copyright © {new Date().getFullYear()} AssessFamilyLaw.org. All Rights Reserved.
            </div>
          </div>

          <div className="col-lg-7 col-md-12 footer-links">
            <ul className="d-md-flex">
              <li>
                <Link to="/seefinishedassessments">See Finished Assessments</Link>
              </li>
              <li>
                <Link to="/about">About AFL</Link>
              </li>
              <li>
                <Link to="/importantposts">Important Posts</Link>
              </li>
              <li>
                <Link to="/contactus">Contact Us</Link>
              </li>
            </ul>
          </div>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
